module.exports = __webpack_public_path__ + "06579c69763efcdf46e7f4b0da7bbd41.svg";